import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SaveIcon from '@mui/icons-material/Save';
import {
  Box,
  Button,
  Checkbox,
  Collapse,
  Drawer,
  FormControlLabel,
  Grid,
  IconButton,
  LinearProgress,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Tooltip from '@mui/material/Tooltip';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { useUtil } from 'src/components/hooks/useUtil';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import { usePublishDOAtoISFMutation, useUpdatePublishDOAtoISFMutation } from 'src/services/DOA';
import { useAppDispatch } from 'src/store';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppSelector } from 'src/store/hooks';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useSiteContactInfo } from '../steps/useSitecontactinfo';
import './StudyLogs.scss';
import { useDOA } from './useDOA';
import { setIsbacktositepersonnel } from 'src/store/SiteStudyPersonnel';
import { setPath } from 'src/store/Navigation';
import { useTab } from 'src/components/hooks/useTab';
import Loader from 'src/components/common/Loader';
import { archLevel } from 'src/data/config';
import ESignConsentReAuth from 'src/components/common/ESignConsentReAuth';
import { useLazySetESignQuery } from 'src/services/ESignAPI';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { useValidUserForReAuth } from 'src/components/hooks/useValidUserForReAuth';
export interface IPageLevelSignInfo {
  pi_name: string | null;
  pi_signature_date_time: string | null;
  pi_signature_reason: string;
}
export interface IExpandItems {
  [key: string]: boolean;
}
const DeligationOfAuth: React.FunctionComponent<any> = ({ setStudyLogOpen, setDOAOpen, personelRoleData }) => {
  const sitePersonelRoleData = personelRoleData;
  const [expandedItems, setExpandedItems] = React.useState<IExpandItems>({});
  const { isValidUserForReAuth } = useValidUserForReAuth();
  const { checkPermission } = usePermissionWrapper();
  const { user }: any = useUser();
  const rolePIL = checkPermission('publish_sl_doa');
  const dispatchApp: any = useAppDispatch();
  const progress = false;
  const { preferedDateFormat, userPreferedDateFormat, getPreferredDateTimeInLocal, getServerDateOrInvalidDayJs } =
    usePreferedDateFormat();
  const [openSignConsent, setOpenSignConsent] = useState(false);
  const [openPageLevelSignConsent, setOpenPageLevelSignConsent] = useState(false);
  const { selectedAppSection } = useSelectedAppInfo();
  const [personalData, setPersonalData] = useState<any>([]);
  const [openDilog, setOpenDilog] = React.useState(false);
  const [startDate, setStartDate] = React.useState<string | null>(null);
  const [deleteOn, setDeleteOn] = useState(false);
  const [back, setBack] = useState(false);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const application = process.env.REACT_APP_NAME;
  const { setTabVal, tabsData } = useTab();
  const [endDate, setEndDate] = React.useState<string | null>(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [disablePublish, setDisablePublish] = useState<boolean>(false);
  const [disablePageLevelSign, setDisablePageLevelSign] = useState<boolean>(true);
  const hasUpdatePermission = checkPermission('update_site_doa');
  const [checkedCheckBoxval, setcheckedCheckBoxval] = useState([]);
  const [trainingtextfilederror, settrainingtextfilederror] = useState(false);
  const { siteStudyPersonnelQueryData, siteStudyPersonnelQueryDataError, getSiteStudyPersonnelQueryData } =
    useSiteContactInfo();
  const {
    doaLinkQueryData,
    getDOALinkIsError,
    getDOALinkQueryData,
    getPageLevelSignData,
    updatePageLevelSignature,
    updateDOALink,
    createDOALinkIsSuccess,
    createDOALink,
    deleteDOALink
  } = useDOA();

  const [setESignature] = useLazySetESignQuery();

  const { DOA, unSavedWarning, otherFields, applicationModuleSection } = useFieldTranslation();
  const [
    publishDOAtoISF,
    { isLoading: publishDOAtoISFLoading, error: publishDOAtoISFError, isSuccess: publishDOAtoISFIsSuccess }
  ] = usePublishDOAtoISFMutation();
  const [updatePublishDOAtoISF, { isLoading: updatePublishDOAtoISFLoading }] = useUpdatePublishDOAtoISFMutation();
  useEffect(() => {
    if (updatePublishDOAtoISFLoading || publishDOAtoISFLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [updatePublishDOAtoISFLoading, publishDOAtoISFLoading]);
  const [logData, setLogData] = useState<any>({
    startdate: '',
    enddate: '',
    study_activities: '',
    other_study_activities: '',
    updated_by: user
  });
  const [validateChanges, setValidateChanges] = useState({
    startdate: '',
    enddate: '',
    study_activities: '',
    other_study_activities: '',
    updated_by: user
  });
  const [openDilogPersonalSignature, setOpenDilogPersonalSignature] = useState(false);
  const [piId, setPIid] = useState('');
  const [signType, setSignType] = useState('');
  const [pageLevelSignInfo, setPageLevelSignInfo] = useState<Partial<IPageLevelSignInfo>>({
    pi_name: null,
    pi_signature_date_time: null,
    pi_signature_reason: ''
  });
  const [openDilogInvestiSign, setOpenDilogInvestiSign] = useState(false);
  const [openDailogPageLevelSign, setOpenDailogPageLevelSign] = useState(false);
  const textRef: any = useRef(null);
  const [deletePopup, setDeletePopup] = useState(false);
  const [tooltipOpen, setTooltpOpen] = useState(false);
  const isBacktoSitepersonnel = useAppSelector(state => state.siteStudyPersonnel.isBacktoSitepersonnel);
  const doaVersion = doaLinkQueryData && doaLinkQueryData.StudyLogs[0].Personnel[0].doa_publish_version;

  const tooltipCloseHandle = (name: string) => {
    if (name === 'move') {
      handleDOAClose();
    }
    if (name === 'cnf') {
      setDateEnable(false);
      setcheckedCheckBoxval([]);
      setConfirmExitValue(dispatch, false);
      handleAdd(rowName);
    }
    if (name === 'delete') {
      handleClose(rowName);
      setaddPersonlaBtn(true);
      setDeletePopup(true);
      handleDelete(piId);
      setDeleteOn(false);
      setDateEnable(false);
    }
    setTooltpOpen(false);
  };
  const handleFormatDate = (value: any) => {
    return preferedDateFormat(value);
  };
  const [validationObj, setValidationObj] = useState<any>({
    first_name: false,
    last_name: false,
    role: false,
    startdate: false,
    study_activities: false
  });

  const isValidsiteInfoData = () => {
    const newValidObj: any = { ...validationObj };
    const validationArr: any = [];
    for (const key of Object.keys(validationObj)) {
      if (creatDoaObj[key] === '' || creatDoaObj[key] === null) {
        newValidObj[key] = true;
        validationArr.push(false);
      }
    }
    setValidationObj(newValidObj);
    if (validationArr?.includes(false)) {
      return false;
    } else {
      return true;
    }
  };

  const getDOAData = async () => {
    const doaResponse: any = await getDOALinkQueryData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME
    });
    if (
      doaResponse?.data?.StudyLogs?.length &&
      doaResponse?.data?.StudyLogs?.[0]?.Personnel?.[0]?.doa_publish_version !== 0
    ) {
      setDisablePublish(true);
    }
    const objData: any = [];
    if (doaResponse?.isSuccess) {
      getDOAPageLevelSinatureData();
      const personRows: IExpandItems = {};
      sitePersonelRoleData?.map((item: any) => {
        const foundItem = doaResponse?.data.StudyLogs.find((obj: any) => obj.role == item.name);
        if (foundItem) {
          personRows[item.id] = true;
          const tempArr = foundItem.Personnel?.map((ele: any) => {
            return { ...ele, personnel_signature_button: false, prior_to_study_pi_signature_button: false };
          });
          objData.push({ role: foundItem.role, Personnel: tempArr });

          if (pageLevelSignInfo.pi_name !== null && doaVersion !== 1) {
            setDisablePublish(false);
          } else {
            setDisablePublish(tempArr[0].is_submit);
          }
        } else {
          objData.push({ role: item.name, Personnel: [] });
        }
      });
      setExpandedItems(personRows);
    } else if (doaResponse?.isError) {
      sitePersonelRoleData?.map((item: any) => {
        objData.push({ role: item.name, Personnel: [] });
      });
      setPageLevelSignInfo({
        pi_name: null,
        pi_signature_date_time: null
      });
    } else {
      sitePersonelRoleData?.map((item: any) => {
        objData.push({ role: item.name, Personnel: [] });
      });
    }
    setPersonalData(objData);
  };
  const handleDilogClose = () => {
    setOpenDilog(false);
    const arr = creatDoaObj.study_activities?.split(',');
    const studyActivitiesArr: any = [];
    studyActivity?.map((ele: any) => {
      if (arr?.includes(ele.id.toString())) {
        studyActivitiesArr.push({ id: ele.id, val: ele.id.toString() });
      } else if (ele == 'Other' && arr?.includes('99')) {
        studyActivitiesArr.push({ id: '99', val: '99' });
      }
    });
    setLogData({ ...logData, other_study_activities: '' });
    setcreatDoaObj({ ...creatDoaObj, other_study_activities: '' });
    setcheckedCheckBoxval(studyActivitiesArr);
    settrainingtextfilederror(false);
  };
  const { data }: any = useGetCodeListDataQuery('STACTIV');
  const [studyActivity, setStudyActivities] = useState<any>([]);
  useEffect(() => {
    if (data) {
      const tempStudyActivity: any = [];
      data?.map((ele: any, index: number) => {
        tempStudyActivity.push({ id: index + 1, ele: ele.code_list_value });
      });
      setStudyActivities(tempStudyActivity);
    }
  }, [data]);

  const [sitePersonnels, setsitePersonnels] = useState([]);
  const handlePersonnelSignature = (item: any) => {
    if (user === `${item.first_name} ${item.last_name}`) {
      setPIid(item.id);
      setOpenDilogPersonalSignature(true);
    }
  };
  const getDOAPageLevelSinatureData = async () => {
    const response: any = await getPageLevelSignData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application,
      application_module_section: applicationModuleSection.studyLogs
    });
    if (response?.isSuccess && response?.data.pi_name !== null) {
      setPageLevelSignInfo({
        pi_name: response?.data.pi_name,
        pi_signature_date_time: response?.data.pi_signature_date_time,
        pi_signature_reason: response?.data.pi_signature_reason
      });
      setDisablePageLevelSign(true);
    } else {
      setPageLevelSignInfo({
        pi_name: null,
        pi_signature_date_time: null
      });
      setDisablePageLevelSign(false);
    }
  };
  useEffect(() => {
    getDOAPageLevelSinatureData();
  }, []);
  useEffect(() => {
    if (siteStudyPersonnelQueryData) {
      setsitePersonnels(siteStudyPersonnelQueryData.personnel);
    }
  }, [siteStudyPersonnelQueryData]);

  useEffect(() => {
    if (siteStudyPersonnelQueryDataError) {
      setsitePersonnels([]);
    }
  }, [siteStudyPersonnelQueryDataError]);

  useEffect(() => {
    getDOAData();
    getSiteStudyPersonnelQueryData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application,
      site_users: true,
      strictly_site_users: true
    });
  }, [selectedSite]);

  const handleDilogPersonalSignClose = () => {
    setOpenDilogPersonalSignature(false);
  };
  const piSignDisable = checkPermission('pi_sign_doa');
  const handleDelete = async (id: any) => {
    setPIid(id);
    if (addPersonlaBtn && !dateEnable) {
      setDeletePopup(true);
    } else {
      setTooltpOpen(true);
      setDeleteOn(true);
    }
  };
  const [dateEnable, setDateEnable] = useState(false);
  const [takeid, setTakeId] = useState('');
  const handleEdit = (item: any) => {
    setStartDate(item.startdate);
    setEndDate(item.enddate);
    setDateEnable(true);
    setLogData({
      ...logData,
      study_activities: item.study_activities,
      other_study_activities: item.other_study_activities,
      startdate: item.startdate,
      enddate: item.enddate
    });
    setValidateChanges({
      ...validateChanges,
      study_activities: item.study_activities,
      other_study_activities: item.other_study_activities,
      startdate: item.startdate,
      enddate: item.enddate
    });
    setTakeId(item.id);
    setPIid(item.id);
    setConfirmExitValue(dispatch, true);
  };
  const handleCloseEdit = () => {
    setDateEnable(false);
    setcheckedCheckBoxval([]);
    getDOAData();
    setConfirmExitValue(dispatch, false);
  };
  const handleDilogSignClose = () => {
    setOpenDilogInvestiSign(false);
    setOpenDailogPageLevelSign(false);
  };

  const handleDilogInvestiSignSave = async () => {
    handleDilogSignClose();
    setOpenSignConsent(true);
    setSignType('PI_SIGN');
  };
  const handleDilogPageLevelSignSave = async () => {
    handleDilogSignClose();
    setOpenPageLevelSignConsent(true);
    // updateDOAPageLevelSignature(user);
  };
  const handleSaveEdit = async (item: any) => {
    logData.startdate = startDate;
    logData.enddate = endDate;
    if (
      validateChanges.startdate === logData.startdate &&
      validateChanges.enddate === logData.enddate &&
      validateChanges.study_activities === logData.study_activities &&
      validateChanges.other_study_activities === logData.other_study_activities
    ) {
      dispatchApp(
        dispatch(
          setMessage({ msgDetails: 'No change in data and hence cannot save the information', severity: 'error' })
        )
      );
    } else if (logData.study_activities?.length < 1 || logData.startdate === null) {
      dispatch(setMessage({ msgDetails: 'Mandatory Information is Missing.', severity: 'error' }));
    } else {
      const datevalidation =
        logData.startdate !== '' && logData.enddate !== '' ? moment(logData.startdate) > moment(logData.enddate) : true;
      if (datevalidation) {
        dispatch(setMessage({ msgDetails: 'start date should be less than end date.', severity: 'error' }));
      } else {
        await updateDOALink({
          id: item.id,
          data: logData,
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          application: process.env.REACT_APP_NAME
        });
        if (
          (item.study_activities !== logData.study_activities || item.startdate != logData.startdate) &&
          (item.personnel_signature !== null || item.prior_to_study_pi_signature !== null)
        ) {
          await updatePublishDOAtoISF(updatePublishObject);
          setDisablePublish(false);
        }
        await getDOAData();
        setDateEnable(false);
        await updatePublishDOAtoISF(updatePublishObject);
        setDisablePublish(false);
        setLogData({ startdate: '', enddate: '', study_activities: '', other_study_activities: '', updated_by: user });
        setcheckedCheckBoxval([]);
        setaddPersonlaBtn(true);
        setStartDate(null);
        setEndDate(null);
      }
    }
    setConfirmExitValue(dispatch, false);
  };
  const handlePISign = (item: any) => {
    setPIid(item.id);
    setOpenDilogInvestiSign(true);
  };

  const handlePIPageLevelSign = async () => {
    setOpenDailogPageLevelSign(true);
  };
  const updatePublishObject = {
    isSubmit: false,
    site_id: selectedSite,
    study_id: studyId
  };

  const publishToISF = async () => {
    dispatch(showLoader());
    await publishDOAtoISF({
      isUpdate: doaVersion !== 0.0 ? true : false,
      publish_doc_version:
        pageLevelSignInfo.pi_name !== null || doaVersion !== 0.0
          ? pageLevelSignInfo.pi_name !== null
            ? 1
            : doaVersion >= 0.9
            ? doaVersion === 0.9
              ? Math.floor(1).toFixed(1)
              : Math.floor(doaVersion + 1).toFixed(1)
            : (doaVersion + 1).toFixed(1)
          : 1,
      isSubmit: true,
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      application_module_section: 'STUDY LOGS'
    });
    dispatch(hideLoader());
  };
  useEffect(() => {
    if (publishDOAtoISFIsSuccess) {
      dispatchApp(
        setMessage({ msgDetails: 'Study Log successfully published to ISF repository', severity: 'success' })
      );
      setDisablePublish(true);
    } else if (publishDOAtoISFError) {
      dispatchApp(setMessage({ msgDetails: 'Study Log publish is getting Error', severity: 'error' }));
    }
  }, [publishDOAtoISFIsSuccess, publishDOAtoISFError]);

  const [creatDoaObj, setcreatDoaObj] = useState<any>({
    first_name: '',
    last_name: '',
    role: '',
    startdate: null,
    enddate: null,
    study_activities: '',
    other_study_activities: '',
    created_by: user
  });
  const [invalidStartDate, setInvalidStartDate] = useState<boolean>(false);
  const [invalidEndDate, setInvalidEndDate] = useState<boolean>(false);
  const dispatch = useDispatch();

  const saveRecord = async () => {
    if (invalidStartDate || invalidEndDate) {
      dispatch(setMessage({ msgDetails: 'Invalid Date(s)', severity: 'error' }));
    } else if (isValidsiteInfoData()) {
      const datevalidation =
        creatDoaObj.startdate != null && creatDoaObj.enddate != ''
          ? moment(creatDoaObj.startdate) > moment(creatDoaObj.enddate)
          : false;
      if (datevalidation) {
        dispatch(setMessage({ msgDetails: 'start date should be less than end date.', severity: 'error' }));
      } else {
        await createDOALink({
          site_id: selectedSite,
          study_id: studyId,
          data: creatDoaObj,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME
        });
        await updatePublishDOAtoISF(updatePublishObject);
      }
    } else {
      dispatch(setMessage({ msgDetails: 'Missing Mandary Data', severity: 'error' }));
    }
    setDisablePublish(false);
  };
  const setDataAfterCreateDOALink = async () => {
    setcreatDoaObj({
      first_name: '',
      last_name: '',
      role: '',
      startdate: null,
      enddate: null,
      study_activities: '',
      other_study_activities: '',
      created_by: user
    });
    setLogData({ startdate: '', enddate: '', study_activities: '', other_study_activities: '', updated_by: user });
    setaddFields({
      first_name: false,
      last_name: false,
      role: '',
      startdate: '',
      enddate: '',
      study_activities: false
    });
    setcheckedCheckBoxval([]);
    setaddPersonlaBtn(true);
    setStartDate(null);
    setEndDate(null);
    await getDOAData();
  };
  useEffect(() => {
    if (createDOALinkIsSuccess) {
      setDataAfterCreateDOALink();
    }
  }, [createDOALinkIsSuccess]);
  const handleDilogPersonalSignSave = async () => {
    setOpenDilogPersonalSignature(false);
    setOpenSignConsent(true);
    setSignType('PERSONAL_SIGN');
  };
  const saveNewRecord = async (name: string) => {
    saveRecord();
    setInvalidStartDate(false);
    setInvalidEndDate(false);
    setConfirmExitValue(dispatch, false);
    setDisablePublish(false);
  };

  const handleDilogOpen = () => {
    setOpenDilog(true);
  };

  const handleSaveActivities = () => {
    if (
      checkedCheckBoxval.find((item: any) => item.val == '99') &&
      (logData.other_study_activities == '' || logData.other_study_activities == null) &&
      creatDoaObj.other_study_activities == ''
    ) {
      settrainingtextfilederror(true);
    } else {
      if (!checkedCheckBoxval.find((item: any) => item.val == '99')) {
        settrainingtextfilederror(false);
        logData.other_study_activities = '';
        creatDoaObj.other_study_activities = '';
      }
      const stringValues: any = [];
      if (checkedCheckBoxval) {
        checkedCheckBoxval?.map((item: any) => {
          stringValues.push(item.val);
        });
      }
      setcreatDoaObj({ ...creatDoaObj, study_activities: stringValues.toString() });
      setLogData({ ...logData, study_activities: stringValues.toString() });
      setOpenDilog(false);
      if (takeid !== '') {
        const tempPersonal = JSON.parse(JSON.stringify(personalData));
        tempPersonal?.map((item: any) => {
          item.Personnel?.map((obj: any) => {
            if (takeid == obj.id) {
              obj.study_activities = stringValues.toString();
            }
          });
        });
        setPersonalData(tempPersonal);
      }
    }
  };
  const handleDeletePopupClose = () => {
    setDeletePopup(false);
  };
  const handleStudyCheckbox = (e: any, index: number) => {
    let objArr: any = checkedCheckBoxval;
    if (e.target.checked) {
      objArr.push({ id: index, val: e.target.value });
    } else {
      objArr = checkedCheckBoxval.filter((item: any) => item.val !== e.target.value);
    }
    setcheckedCheckBoxval(objArr);
  };
  const handleChange = (e: any, name: string) => {
    const first = e.target.value;
    const filtered: any = sitePersonnels.find(
      (ele: any) => `${ele.site_per_first_name} ${ele.site_per_last_name}` === first
    );
    setcreatDoaObj({
      ...creatDoaObj,
      first_name: filtered.site_per_first_name,
      last_name: filtered.site_per_last_name,
      startdate: filtered.site_per_startdate,
      study_activities: filtered.site_per_activities,
      role: name
    });
    const arr = filtered.site_per_activities?.split(',');
    const studyActivitiesArr: any = [];
    studyActivity?.map((ele: any) => {
      if (arr?.includes(ele.id.toString())) {
        studyActivitiesArr.push({ id: ele.id, val: ele.id.toString() });
      } else if (arr?.includes('99')) {
        studyActivitiesArr.push({ id: '99', val: '99' });
      }
    });
    setcheckedCheckBoxval(studyActivitiesArr);
    setaddFields({ ...addFields, first_name: true, last_name: true });
  };

  const [addFields, setaddFields] = useState({
    first_name: false,
    last_name: false,
    role: '',
    startdate: '',
    enddate: '',
    study_activities: false
  });
  const handleClickAdd = () => {
    setaddFields({ ...addFields, first_name: false, last_name: false });
  };
  const handleDeleteconfirm = async () => {
    handleDeletePopupClose();
    const reqObj = {
      deleted_by: user
    };
    await deleteDOALink({
      id: piId,
      data: reqObj,
      study_id: studyId,
      country: selectedCountry,
      site_id: selectedSite,
      application: process.env.REACT_APP_NAME
    });
    await updatePublishDOAtoISF(updatePublishObject);
    await getDOAData();
    setDisablePublish(false);
    setPIid('');
  };

  const [addPersonlaBtn, setaddPersonlaBtn] = useState(true);
  const handleDOAClose = () => {
    setStudyLogOpen(true);
    setConfirmExitValue(dispatch, false);
    setDOAOpen(false);
  };

  const handleAdd = (name: any) => {
    const itemRoles: any = [];
    if (personalData?.length > 0) {
      personalData?.map((item: any) => {
        if (item.role === name) {
          itemRoles.push({ role: item.role, Personnel: [...item.Personnel, {}] });
        } else {
          itemRoles.push({ role: item.role, Personnel: [...item.Personnel] });
        }
      });
      setPersonalData(itemRoles);
    } else {
      personalData.push({ role: name, Personnel: [{}] });
    }
    setaddPersonlaBtn(false);
    setConfirmExitValue(dispatch, true);
    const expandItem: IExpandItems = { ...expandedItems };
    sitePersonelRoleData?.map((item: any) => {
      if (item.name === name) {
        expandItem[item.id] = true;
      }
    });
    setExpandedItems(expandItem);
  };
  const [rowName, setRowName] = useState('');
  const checkActive = (name: any) => {
    setRowName(name);
    if (dateEnable) {
      setTooltpOpen(true);
    } else {
      handleAdd(name);
    }
    setValidationObj({
      first_name: false,
      last_name: false,
      role: false,
      startdate: false,
      study_activities: false
    });
  };

  useEffect(() => {
    textRef?.current?.focus();
  }, [addPersonlaBtn]);

  const handleClose = (name: string) => {
    personalData?.map((item: any) => {
      if (item.role === name) {
        item.Personnel.pop();
      }
    });
    setcreatDoaObj({
      first_name: '',
      last_name: '',
      role: '',
      startdate: null,
      enddate: null,
      study_activities: '',
      other_study_activities: '',
      created_by: user
    });
    setaddFields({
      first_name: false,
      last_name: false,
      role: '',
      startdate: '',
      enddate: '',
      study_activities: false
    });
    setcheckedCheckBoxval([]);
    setStartDate(null);
    setEndDate(null);
    setaddPersonlaBtn(true);
    setInvalidStartDate(false);
    setInvalidEndDate(false);
    setConfirmExitValue(dispatch, false);
  };

  const permission = !checkPermission('doastudylog_publishtoisf') || getDOALinkIsError;
  const sign = disablePublish || doaVersion < 0.0 ? true : false;

  const addNewPersonal = (index: number, name: string) => {
    return (
      <TableRow className="crud-row">
        <TableCell />
        <TableCell>
          {addFields.first_name ? (
            <span onClick={() => handleClickAdd()} style={{ cursor: 'pointer' }}>
              {creatDoaObj.first_name}
            </span>
          ) : (
            <TextField
              sx={{ textAlign: 'start' }}
              select
              key={index}
              placeholder="First Name"
              required
              inputRef={textRef}
              value={creatDoaObj.first_name}
              onChange={(e: any) => handleChange(e, name)}
              name="first_name"
              error={validationObj.first_name}
              helperText={validationObj.first_name ? 'Required' : ''}
              variant="standard"
            >
              {sitePersonnels?.map((option: any) => {
                if (name === option.site_per_role) {
                  return (
                    <MenuItem
                      placeholder="First Name"
                      key={`${option.site_per_first_name} ${option.site_per_last_name}`}
                      value={`${option.site_per_first_name} ${option.site_per_last_name}`}
                    >
                      {`${option.site_per_first_name} ${option.site_per_last_name}`}
                    </MenuItem>
                  );
                }
              })}
            </TextField>
          )}
        </TableCell>
        <TableCell>{addFields.last_name ? creatDoaObj.last_name : '-'}</TableCell>
        <TableCell>
          <Button onClick={handleDilogOpen}>
            {creatDoaObj.study_activities?.length > 0
              ? creatDoaObj.study_activities.toString()?.length > 10
                ? `${creatDoaObj.study_activities.toString().slice(0, 10)}...`
                : creatDoaObj.study_activities.toString()
              : '---'}
          </Button>
        </TableCell>
        <TableCell className="withDatePicker">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack>
              <DatePicker
                inputFormat={userPreferedDateFormat.toUpperCase()}
                value={creatDoaObj.startdate}
                onChange={newValue => {
                  if (newValue != null) {
                    const changedDate = getServerDateOrInvalidDayJs(newValue);
                    if (changedDate?.length === 10 && changedDate !== 'Invalid Date') {
                      setcreatDoaObj({ ...creatDoaObj, startdate: changedDate });
                      setValidationObj({ ...validationObj, startdate: false });
                      setInvalidStartDate(false);
                    } else {
                      setInvalidStartDate(true);
                    }
                  } else {
                    setcreatDoaObj({ ...creatDoaObj, startdate: null });
                    setInvalidStartDate(false);
                  }
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    variant="standard"
                    required
                    helperText={validationObj.startdate ? 'Required' : ''}
                    error={invalidStartDate || validationObj.startdate}
                  />
                )}
              />
            </Stack>
          </LocalizationProvider>
        </TableCell>
        <TableCell>&nbsp;</TableCell>
        <TableCell>&nbsp;</TableCell>
        <TableCell className="withDatePicker">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack spacing={3}>
              <DatePicker
                inputFormat={userPreferedDateFormat.toUpperCase()}
                value={creatDoaObj.enddate}
                onChange={newValue => {
                  if (newValue != null) {
                    const changedDate = getServerDateOrInvalidDayJs(newValue);
                    if (changedDate?.length === 10 && changedDate !== 'Invalid Date') {
                      setcreatDoaObj({ ...creatDoaObj, enddate: changedDate });
                      setInvalidEndDate(false);
                    } else {
                      setInvalidEndDate(true);
                    }
                  } else {
                    setcreatDoaObj({ ...creatDoaObj, enddate: null });
                    setInvalidEndDate(false);
                  }
                }}
                renderInput={params => <TextField {...params} variant="standard" error={invalidEndDate} />}
              />
            </Stack>
          </LocalizationProvider>
        </TableCell>
        <TableCell className="actionTd">
          <IconButton style={{ cursor: 'pointer' }} onClick={() => saveNewRecord(name)}>
            {' '}
            <SaveIcon />
          </IconButton>
          <IconButton style={{ cursor: 'pointer' }} onClick={() => handleClose(name)}>
            {' '}
            <CloseIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    );
  };

  const navigateToSitInfo = () => {
    dispatch(setPath('DOA'));
    const currentTabinfo: any = tabsData.filter((item: any) => item.key === 'siteContactInfo');
    setTabVal(currentTabinfo[0].index);
  };

  useEffect(() => {
    return () => {
      dispatch(setIsbacktositepersonnel(false));
    };
  }, []);
  const handleTooltipOpen = () => {
    if (dateEnable || !addPersonlaBtn) {
      setTooltpOpen(true);
      setBack(true);
      dispatch(setIsbacktositepersonnel(false));
    } else if (isBacktoSitepersonnel) {
      navigateToSitInfo();
      dispatch(setIsbacktositepersonnel(false));
    } else {
      setStudyLogOpen(true);
      setDOAOpen(false);
    }
  };

  const edithandleDilogOpen = (studyActivies: any) => {
    setcheckedCheckBoxval(studyActivies);
    setOpenDilog(true);
  };
  const handleotherTainingChange = (e: any) => {
    settrainingtextfilederror(false);
    setLogData({ ...logData, other_study_activities: e.target.value });
    setcreatDoaObj({ ...creatDoaObj, other_study_activities: e.target.value });
  };
  const handleOk = () => {
    if (dateEnable && back) {
      tooltipCloseHandle('move');
    } else if (!addPersonlaBtn && back) {
      tooltipCloseHandle('move');
    } else if (dateEnable && deleteOn) {
      tooltipCloseHandle('delete');
    } else if (!addPersonlaBtn && deleteOn) {
      tooltipCloseHandle('delete');
    } else {
      tooltipCloseHandle('cnf');
    }
    setBack(false);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { openModal, closeModal } = useUtil();
  useEffect(() => {
    if (openDrawer) {
      openModal();
    } else {
      closeModal();
    }
    return () => {
      closeModal();
    };
  }, [openDrawer]);

  const handleRowPISign = async (data: any = {}) => {
    if (data.success) {
      if (!isValidUserForReAuth(data.records.user_name)) {
        dispatch(setMessage({ msgDetails: `Please e-sign with the logged in username`, severity: 'error' }));
      } else {
        setOpenSignConsent(false);
        dispatch(showLoader());
        let dataObj;
        switch (signType) {
          case 'PI_SIGN':
            dataObj = {
              username: data.records.user_name,
              password: data.records.password,
              module_name: 'DOA Link',
              name_of_signature: 'prior_to_study_pi_signature',
              name_of_date_field: 'prior_to_study_pi_signature_date_time',
              id: piId,
              columns_to_change: {
                prior_to_study_pi_signature_reason: data.records.sign_reason,
                updated_by: user
              }
            };
            break;
          case 'PERSONAL_SIGN':
            dataObj = {
              username: data.records.user_name,
              password: data.records.password,
              module_name: 'DOA Link',
              name_of_signature: 'personnel_signature',
              name_of_date_field: 'personnel_signature_date_time',
              id: piId,
              columns_to_change: {
                personnel_signature_reason: data.records.sign_reason,
                updated_by: user
              }
            };
            break;
        }

        const signatureResponse: any = await setESignature({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          application_section: selectedAppSection,
          application_module_section: applicationModuleSection.studyLogs,
          data: dataObj
        });
        if (signatureResponse.isSuccess) {
          dispatch(
            setMessage({
              msgDetails: 'Signed',
              severity: 'success'
            })
          );
          updatePublishDOAtoISF(updatePublishObject);
          setDisablePublish(false);
          getDOAData();
        } else if (signatureResponse.isError) {
          dispatch(setMessage({ msgDetails: `Authorization for ${data.records.user_name} failed`, severity: 'error' }));
        }
        dispatch(hideLoader());
      }
    }
  };

  const handlePageLevelSign = async (data: any = {}) => {
    if (data.success) {
      if (!isValidUserForReAuth(data.records.user_name)) {
        dispatch(setMessage({ msgDetails: `Please e-sign with the logged in username`, severity: 'error' }));
      } else {
        setOpenPageLevelSignConsent(false);

        const response: any = await updatePageLevelSignature({
          data: { pi_name: user, pi_signature_reason: data.records.sign_reason, updated_by: user },
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          username: data.records.user_name,
          password: data.records.password,
          application: process.env.REACT_APP_NAME,
          application_module_section: applicationModuleSection.studyLogs
        });
        if (response?.isSuccess && user !== null) {
          dispatch(setMessage({ msgDetails: 'Signed', severity: 'success' }));
          await updatePublishDOAtoISF(updatePublishObject);
          setDisablePublish(false);
        } else if (response?.isError) {
          dispatch(setMessage({ msgDetails: `Authorization for ${data.records.user_name} failed`, severity: 'error' }));
        }
        await getDOAPageLevelSinatureData();
        await getDOAData();
      }
    }
  };

  return (
    <>
      <Box mt={-1}>
        {isBacktoSitepersonnel ? (
          <Button onClick={handleTooltipOpen} startIcon={<ArrowBackIcon fontSize="small" />}>
            back to site personnel details
          </Button>
        ) : (
          <Button onClick={handleTooltipOpen} startIcon={<ArrowBackIcon fontSize="small" />}>
            {DOA.label15}
          </Button>
        )}
        / {DOA.component}
      </Box>
      <Loader />
      <div className="pi-accordion study-log">
        <Grid container>
          <Grid md={12}>
            <Typography>
              <TableContainer className="studylog-table">
                {progress ? <LinearProgress /> : ''}
                <Table aria-label="collapsible table" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>{DOA.label1}</TableCell>
                      <TableCell>{DOA.label2}</TableCell>
                      <TableCell>{DOA.label3}</TableCell>
                      <TableCell className="withHelpIcon">
                        {DOA.label4}
                        <Tooltip title="View Study Activities" placement="top" arrow>
                          <HelpOutlineIcon onClick={() => setOpenDrawer(true)} />
                        </Tooltip>
                      </TableCell>
                      <TableCell className="dateCol">{DOA.label5}</TableCell>
                      <TableCell className="signCol">{DOA.label6}</TableCell>
                      <TableCell className="signCol">{DOA.label7}</TableCell>
                      <TableCell className="dateCol">{DOA.label8}</TableCell>
                      <TableCell>{DOA.label9}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody key={sitePersonelRoleData?.length}>
                    {sitePersonelRoleData?.map((row: any) => {
                      const itemRows: any = [];
                      let tempLenth = 0;
                      personalData?.map((item: any) => {
                        if (item.role === row.name) {
                          if (item.Personnel !== undefined) {
                            const length = item.Personnel.filter((obj: any) => Object.keys(obj)?.length > 0)?.length;
                            sitePersonelRoleData?.map((ele: any) => {
                              if (ele.id === row.id) {
                                tempLenth = length;
                              }
                            });
                          }
                          const rowt = (
                            <>
                              {item.Personnel?.map((item: any, index: number) => {
                                if (Object.keys(item)?.length > 0) {
                                  const priorDateTime = getPreferredDateTimeInLocal(
                                    item.prior_to_study_pi_signature_date_time
                                  );
                                  const personalDateTime = getPreferredDateTimeInLocal(
                                    item.personnel_signature_date_time
                                  );
                                  let studyActiviesNumbers = '';
                                  const studyActivies: any = item.study_activities?.split(',');
                                  const studyActivitiesArr: any = [];
                                  studyActivity?.map((ele: any, index: number) => {
                                    if (studyActivies?.includes(ele.id.toString())) {
                                      studyActivitiesArr.push({ id: ele.id, val: ele.id.toString() });
                                      studyActiviesNumbers = `${studyActiviesNumbers + (ele.id + 1)},`;
                                    } else if (ele.ele == 'Other' && studyActivies?.includes('99')) {
                                      studyActivitiesArr.push({ id: '99', val: '99' });
                                      studyActiviesNumbers = `${studyActiviesNumbers}99,`;
                                    }
                                  });

                                  return (
                                    <TableRow
                                      key={item.id}
                                      className={dateEnable && takeid === item.id ? 'crud-row' : ''}
                                    >
                                      <TableCell />
                                      <TableCell>{item.first_name}</TableCell>
                                      <TableCell>{item.last_name}</TableCell>
                                      <TableCell>
                                        {dateEnable && takeid === item.id ? (
                                          <Button onClick={() => edithandleDilogOpen(studyActivitiesArr)}>
                                            {logData.study_activities?.length > 6
                                              ? `${logData.study_activities.slice(0, 6)}...`
                                              : logData.study_activities.replace(/,\s*$/, '')}
                                          </Button>
                                        ) : (
                                          <div>
                                            {item.study_activities?.length > 6
                                              ? `${item.study_activities.slice(0, 6)}...`
                                              : item.study_activities.replace(/,\s*$/, '')}
                                          </div>
                                        )}
                                      </TableCell>
                                      <TableCell className="withDatePicker">
                                        {dateEnable && takeid === item.id ? (
                                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Stack spacing={3}>
                                              <DatePicker
                                                inputFormat={userPreferedDateFormat.toUpperCase()}
                                                value={startDate}
                                                onChange={newValue => {
                                                  if (newValue != null) {
                                                    const changedDate = getServerDateOrInvalidDayJs(newValue);
                                                    if (changedDate?.length === 10 && changedDate !== 'Invalid Date') {
                                                      setStartDate(changedDate);
                                                    }
                                                  } else {
                                                    setStartDate(null);
                                                  }
                                                }}
                                                renderInput={params => (
                                                  <TextField
                                                    {...params}
                                                    variant="standard"
                                                    required
                                                    error={!startDate}
                                                    helperText={!startDate ? 'Required' : ''}
                                                  />
                                                )}
                                              />
                                            </Stack>
                                          </LocalizationProvider>
                                        ) : (
                                          handleFormatDate(item.startdate)
                                        )}
                                      </TableCell>
                                      <TableCell align="center">
                                        {dateEnable && takeid === item.id ? (
                                          <></>
                                        ) : (
                                          <>
                                            {item.personnel_signature !== null ? (
                                              <Tooltip
                                                disableFocusListener
                                                disableTouchListener
                                                title={
                                                  <div>
                                                    Signed by {item.personnel_signature} on {personalDateTime}
                                                    <br />
                                                    Reason: &ldquo;{item.personnel_signature_reason}&ldquo;
                                                  </div>
                                                }
                                              >
                                                <div>
                                                  {item.first_name} {item.last_name}
                                                </div>
                                              </Tooltip>
                                            ) : item.personnel_signature_button || disablePageLevelSign ? (
                                              <Button size="small" variant="contained" disabled>
                                                {DOA.label12}
                                              </Button>
                                            ) : (
                                              <Button
                                                size="small"
                                                variant="contained"
                                                onClick={() => handlePersonnelSignature(item)}
                                                disabled={
                                                  !(
                                                    checkPermission('siteper_sign_doa') &&
                                                    !(
                                                      `${item.first_name} ${item.last_name}` !== user ||
                                                      (dateEnable && takeid === item.id)
                                                    )
                                                  )
                                                }
                                              >
                                                {DOA.label12}
                                              </Button>
                                            )}
                                          </>
                                        )}
                                      </TableCell>
                                      <TableCell align="center">
                                        {dateEnable && takeid === item.id ? (
                                          <></>
                                        ) : (
                                          <>
                                            {item.prior_to_study_pi_signature !== null ? (
                                              <Tooltip
                                                disableFocusListener
                                                disableTouchListener
                                                title={
                                                  <div>
                                                    Signed by {item.prior_to_study_pi_signature} on {priorDateTime}
                                                    <br />
                                                    Reason: &ldquo;{item.prior_to_study_pi_signature_reason}&ldquo;
                                                  </div>
                                                }
                                              >
                                                <div>{item.prior_to_study_pi_signature}</div>
                                              </Tooltip>
                                            ) : item.prior_to_study_pi_signature_button || disablePageLevelSign ? (
                                              <Button size="small" variant="contained" disabled>
                                                {DOA.label12}
                                              </Button>
                                            ) : (
                                              <Button
                                                size="small"
                                                variant="contained"
                                                onClick={() => handlePISign(item)}
                                                disabled={!piSignDisable}
                                              >
                                                {DOA.label12}
                                              </Button>
                                            )}
                                          </>
                                        )}
                                      </TableCell>
                                      <TableCell className="withDatePicker">
                                        {dateEnable && takeid === item.id ? (
                                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Stack spacing={3}>
                                              <DatePicker
                                                inputFormat={userPreferedDateFormat.toUpperCase()}
                                                value={endDate == null ? item.enddate : endDate}
                                                onChange={newValue => {
                                                  if (newValue != null) {
                                                    const changedDate = getServerDateOrInvalidDayJs(newValue);
                                                    if (changedDate?.length === 10 && changedDate !== 'Invalid Date') {
                                                      setEndDate(changedDate);
                                                    }
                                                  } else {
                                                    setEndDate(null);
                                                  }
                                                }}
                                                renderInput={params => <TextField {...params} variant="standard" />}
                                              />
                                            </Stack>
                                          </LocalizationProvider>
                                        ) : (
                                          handleFormatDate(item.enddate)
                                        )}
                                      </TableCell>
                                      <TableCell className="actionTd">
                                        {dateEnable && takeid === item.id ? (
                                          <>
                                            <IconButton
                                              style={{ cursor: 'pointer' }}
                                              onClick={() => handleSaveEdit(item)}
                                            >
                                              {' '}
                                              <SaveIcon />
                                            </IconButton>
                                            <IconButton style={{ cursor: 'pointer' }} onClick={handleCloseEdit}>
                                              <CloseIcon />
                                            </IconButton>
                                          </>
                                        ) : (
                                          <>
                                            {hasUpdatePermission ? (
                                              disablePageLevelSign ? (
                                                <IconButton style={{ cursor: 'pointer' }} disabled>
                                                  {' '}
                                                  <EditIcon />{' '}
                                                </IconButton>
                                              ) : (
                                                <IconButton
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => handleEdit(item)}
                                                  disabled={disablePageLevelSign}
                                                >
                                                  {' '}
                                                  <EditIcon />{' '}
                                                </IconButton>
                                              )
                                            ) : (
                                              <></>
                                            )}
                                            {hasUpdatePermission ? (
                                              disablePageLevelSign ? (
                                                <IconButton style={{ cursor: 'pointer' }} disabled>
                                                  {' '}
                                                  <DeleteIcon />
                                                </IconButton>
                                              ) : (
                                                <IconButton
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => handleDelete(item.id)}
                                                  disabled={disablePageLevelSign}
                                                >
                                                  {' '}
                                                  <DeleteIcon />
                                                </IconButton>
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </>
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  );
                                } else {
                                  return addNewPersonal(index, row.name);
                                }
                              })}
                            </>
                          );
                          itemRows.push(rowt);
                        }
                      });
                      return (
                        <>
                          <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} className="category-table">
                            <TableCell component="th" scope="row" colSpan={6}>
                              {row.name} ({tempLenth})
                            </TableCell>
                            <TableCell align="right" colSpan={3}>
                              {hasUpdatePermission ? (
                                <Button
                                  disabled={disablePageLevelSign || !addPersonlaBtn}
                                  onClick={() => checkActive(row.name)}
                                >
                                  + {DOA.label11}
                                </Button>
                              ) : (
                                <></>
                              )}
                              <IconButton
                                aria-label="expand row"
                                disabled={!tempLenth}
                                size="small"
                                onClick={() =>
                                  setExpandedItems({
                                    ...expandedItems,
                                    [row.id]: !expandedItems[row.id]
                                  })
                                }
                              >
                                {expandedItems[row.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                              </IconButton>
                            </TableCell>
                          </TableRow>
                          {itemRows?.length > 0 && (
                            <TableRow>
                              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                                <Collapse in={expandedItems[row.id]} timeout="auto" unmountOnExit>
                                  <Box sx={{ margin: 1 }}>
                                    <TableContainer component={Paper}>
                                      <Table aria-label="simple table">
                                        <TableBody>{itemRows}</TableBody>
                                      </Table>
                                    </TableContainer>
                                  </Box>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          )}
                        </>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box className="Sign_aggrement_statement">
                <Grid container mt={2} columnSpacing={2}>
                  <Grid item md={12}>
                    <Typography variant="h6" mb={1.5}>
                      {DOA.label31}
                    </Typography>
                    <Typography mb={1.5}>{DOA.label32}</Typography>
                  </Grid>
                  <Grid item md={12}>
                    {disablePageLevelSign ? (
                      <span className="signedInfo">
                        Signed by <strong className="textCapitalize">{pageLevelSignInfo.pi_name}</strong> on{' '}
                        <span color="text.secondary">
                          {pageLevelSignInfo.pi_name !== null
                            ? getPreferredDateTimeInLocal(pageLevelSignInfo.pi_signature_date_time)
                            : ''}
                        </span>{' '}
                        <br />
                        <span className="signReasonrow">
                          <span color="text.secondary">Reason:</span> &ldquo;{pageLevelSignInfo.pi_signature_reason}
                          &rdquo;
                        </span>
                      </span>
                    ) : null}
                    {!disablePageLevelSign && (
                      <Button
                        size="small"
                        variant="contained"
                        sx={{ mr: 1.5 }}
                        onClick={() => handlePIPageLevelSign()}
                        // disabled={!(piSignDisable && !getDOALinkIsError)} Updated As per story CTMSKANBAN-7023
                        disabled
                      >
                        {DOA.label12}
                      </Button>
                    )}
                    {rolePIL && (
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => publishToISF()}
                        disabled={permission || sign}
                        sx={{ ml: 2 }}
                      >
                        {DOA.label33}
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </Box>
              <Drawer anchor={'bottom'} open={openDrawer} PaperProps={{ style: { height: '50vh' } }}>
                <Box
                  sx={{ position: 'relative' }}
                  role="presentation"
                  // onClick={() => setOpenDrawer(false)}
                  // onKeyDown={() => setOpenDrawer(false)}
                >
                  <IconButton
                    aria-label="close"
                    onClick={() => setOpenDrawer(false)}
                    sx={{
                      position: 'sticky',
                      left: '100%',
                      top: 8,
                      color: theme => theme.palette.grey[500]
                    }}
                  >
                    <CloseIcon style={{ cursor: 'pointer' }} />
                  </IconButton>
                  <div className="studyActivityWrapper">
                    {studyActivity?.map((ele: any, index: number) => {
                      if (ele.ele === 'Other') {
                        return (
                          <Typography variant="subtitle1" key={99}>
                            <strong>{`${99}`}</strong>. {`${DOA.label19}`}
                          </Typography>
                        );
                      } else {
                        return (
                          <Typography variant="subtitle1" key={ele.id}>
                            <strong>{`${ele.id}`}</strong>. {`${ele.ele}`}
                          </Typography>
                        );
                      }
                    })}
                  </div>
                </Box>
              </Drawer>
            </Typography>
          </Grid>
        </Grid>
        <div>
          <PopupComponent
            open={openDilog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{`${creatDoaObj.first_name} ${creatDoaObj.last_name} ${DOA.label13}`}</DialogTitle>
            <DialogContent className="study-activity-modal">
              <DialogContentText id="alert-dialog-description">{DOA.label14}</DialogContentText>
              {studyActivity?.map((ele: any, index: number) => {
                const found = checkedCheckBoxval.find((item: any) => item.id === ele.id);
                const foundOther = checkedCheckBoxval.find((item: any) => item.val === '99');
                if (ele.ele === 'Other') {
                  return (
                    <FormControlLabel
                      key={99}
                      checked={foundOther}
                      control={<Checkbox value={99} onChange={(e: any) => handleStudyCheckbox(e, 99)} />}
                      label={
                        <>
                          <strong>{'99. '}</strong> <span>{DOA.label19} </span>
                          <TextField
                            value={logData.other_study_activities}
                            onChange={handleotherTainingChange}
                            variant="standard"
                            error={trainingtextfilederror}
                            helperText={trainingtextfilederror ? DOA.label20 : ''}
                          />
                        </>
                      }
                    />
                  );
                } else {
                  return (
                    <FormControlLabel
                      key={ele.id}
                      checked={found}
                      control={<Checkbox value={ele.id} onChange={(e: any) => handleStudyCheckbox(e, ele.id)} />}
                      label={
                        <>
                          <strong>{ele.id}</strong> <span>{ele.ele}</span>
                        </>
                      }
                    />
                  );
                }
              })}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDilogClose} className="grey-btn-link">
                {DOA.label16}
              </Button>
              <Button onClick={handleSaveActivities} autoFocus>
                {DOA.label21}
              </Button>
            </DialogActions>
          </PopupComponent>
        </div>
        <div>
          <PopupComponent
            open={openDilogPersonalSignature}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{DOA.label18}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-text">{DOA.label17}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDilogPersonalSignClose} className="grey-btn-link">
                {DOA.label16}
              </Button>
              <Button onClick={handleDilogPersonalSignSave} autoFocus>
                {DOA.label12}
              </Button>
            </DialogActions>
          </PopupComponent>
        </div>
        <PopupComponent
          open={openDilogInvestiSign || openDailogPageLevelSign}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{DOA.label28}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-text">
              {DOA.label24}
              <ol>
                <li>{DOA.label25}</li>
                <li>{DOA.label26}</li>
                <li>{DOA.label27}</li>
              </ol>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDilogSignClose} className="grey-btn-link">
              {DOA.label16}
            </Button>
            <Button
              onClick={openDilogInvestiSign ? handleDilogInvestiSignSave : handleDilogPageLevelSignSave}
              autoFocus
            >
              {DOA.label12}
            </Button>
          </DialogActions>
        </PopupComponent>
        <PopupComponent
          open={deletePopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{'Delete site personnel?'}</DialogTitle>
          <DialogContent />
          <DialogActions>
            <Button onClick={handleDeletePopupClose}>{otherFields.no}</Button>
            <Button onClick={handleDeleteconfirm} autoFocus>
              {otherFields.yes}
            </Button>
          </DialogActions>
        </PopupComponent>
        <PopupComponent open={tooltipOpen} className="confirm-modal">
          <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => tooltipCloseHandle('stay')} className="grey-btn">
              {DOA.label23}
            </Button>
            <Button onClick={handleOk} autoFocus>
              {DOA.label22}
            </Button>
          </DialogActions>
        </PopupComponent>
      </div>
      {openSignConsent && (
        <ESignConsentReAuth
          openSignConsent={openSignConsent}
          setOpenSignConsent={setOpenSignConsent}
          handleConfirmSign={handleRowPISign}
        />
      )}
      {openPageLevelSignConsent && (
        <ESignConsentReAuth
          openSignConsent={openPageLevelSignConsent}
          setOpenSignConsent={setOpenPageLevelSignConsent}
          handleConfirmSign={handlePageLevelSign}
        />
      )}
    </>
  );
};
export default DeligationOfAuth;
